import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbar4Bar26X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="m8.006 14.148 7.736-9.643C15.446 4.283 12.468 1.846 8 1.846S.554 4.283.258 4.505l7.736 9.637.006.012z"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbar4Bar26X24Px
